import React from 'react'
import { array, number } from 'prop-types'
import styled, { css } from 'styled-components'
import { rgba } from 'polished'

import { mediaDown } from 'styles/media'
import { greyLight, white, borderColor, black } from 'styles/colors'
import { animationTime, animationCurve } from 'styles/global'
import * as spacing from 'styles/spacing'
import { fontSizes, fontWeights } from 'styles/typography'
import Icon from 'components/Icon'

import RightChevron from 'icons/right-chevron.svg'

const Container = styled.div`
  position: relative;
  top: 0;
  z-index: 10;
  background-color: ${white};
`

const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.medium} 0;
  counter-reset: steps;

  ${mediaDown.medium`
    display: none;
  `};
`

const Item = styled.span`
  display: flex;
  align-items: center;
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.medium};

  &:before {
    counter-increment: steps;
    content: counter(steps) '.';
    margin-right: ${spacing.tiny};
  }

  ${props =>
    props.completed &&
    css`
      color: ${black};
      font-weight: ${fontWeights.bold};
      cursor: pointer;
    `}
`

const Chevron = styled.div`
  display: flex;
  color: ${rgba(greyLight, 0.75)};
  margin: 0 ${spacing.medium};
`

const Progress = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${borderColor};
`

const ProgressBar = styled.div`
  width: auto;
  height: 100%;
  background-color: ${black};
  transition: width ${animationTime} ${animationCurve};
`

export default function Breadcrumbs({ items, progress }) {
  return (
    <Container>
      <Inner>
        {items.map((item, i) => {
          if (!item.label) return null

          return (
            <Item key={i} as={item.completed ? 'button' : 'span'} completed={item.completed} onClick={item.onClick}>
              {item.label}
              {i < items.length - 1 && (
                <Chevron>
                  <Icon icon={<RightChevron />} />
                </Chevron>
              )}
            </Item>
          )
        })}
      </Inner>
      <Progress>
        <ProgressBar style={{ width: progress + '%' }} />
      </Progress>
    </Container>
  )
}

Breadcrumbs.propTypes = {
  items: array.isRequired,
  progress: number.isRequired
}
